// extracted by mini-css-extract-plugin
export default {"button--loading":"SplitButton_button--loading__28O5r","button__text":"SplitButton_button__text__aW7bo","button-loading-spinner":"SplitButton_button-loading-spinner__BG1ey"};